module.exports = __webpack_public_path__ + "static/media/jack-pot-of-gold.bb646dfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/game_icons/jack-pot-of-gold.png
// module id = 314
// module chunks = 0